
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface CurrencySelectProps {
  selectedCurrency: string;
  onCurrencyChange: (value: string) => void;
}

export const CurrencySelect = ({
  selectedCurrency,
  onCurrencyChange,
}: CurrencySelectProps) => {
  const { data: currencies, isLoading } = useQuery({
    queryKey: ["currencies"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("currencies")
        .select("*")
        .order("name");
      
      if (error) {
        toast.error("Erreur lors du chargement des devises");
        throw error;
      }
      
      console.log("Devises chargées:", data);
      return data;
    },
  });

  return (
    <div className="space-y-2">
      <Label htmlFor="currency">Devise</Label>
      <Select
        value={selectedCurrency || "GNF"}
        onValueChange={onCurrencyChange}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Sélectionnez une devise" />
        </SelectTrigger>
        <SelectContent>
          {currencies?.map((currency) => (
            <SelectItem key={currency.code} value={currency.code}>
              {currency.name} ({currency.symbol || currency.code})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
